import { motion } from "framer-motion";
import { Check } from "lucide-react";

export const TestingTypes = () => {
  const types = [
    {
      title: "A/B Testing",
      features: [
        "Landing page variations",
        "Call-to-action optimization",
        "Content structure testing",
        "Design element testing"
      ]
    },
    {
      title: "Multivariate Testing",
      features: [
        "Multiple element combinations",
        "Complex page optimization",
        "Interactive element testing",
        "Layout optimization"
      ]
    },
    {
      title: "User Testing",
      features: [
        "Usability studies",
        "User journey analysis",
        "Feedback collection",
        "Behavior tracking"
      ]
    }
  ];

  return (
    <section className="py-24 bg-blue-50">
      <div className="max-w-7xl mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Comprehensive Testing Solutions
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We employ various testing methodologies to ensure thorough optimization
            of your digital presence.
          </p>
        </motion.div>
        <div className="grid md:grid-cols-3 gap-8">
          {types.map((type, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300"
            >
              <h3 className="text-2xl font-semibold mb-6 text-blue-900">
                {type.title}
              </h3>
              <ul className="space-y-4">
                {type.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-start gap-3">
                    <div className="mt-1">
                      <Check className="h-5 w-5 text-blue-500" />
                    </div>
                    <span className="text-gray-600">{feature}</span>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};